<template>
    <div>
    <div  style="padding-top: 100px;" class="wei"><div>您当前位置： 首页 > 资讯中心</div></div>
    <div class="xiang">
           <!--左边-->
             <div class="left">
             <div>行业动态</div>
             <Leftce :list='list'></Leftce>                  
           </div>
           <!--右边-->
           <div class="right">
              <router-view :linew="linew" />
           </div>
    </div>
 </div>
</template>
<script>
import Leftce from '../components/leftce2'
export default {
    data(){
        return{
            list:[],
            linew:[]
        }
    },
    components:{
        Leftce
    },
    created(){
        // this.axios.get('gType/all').then((res)=>{this.list=res.data;});
        this.axios.get('new/all').then((res)=>{this.linew=res.data;});
    },
    mounted(){
        document.documentElement.scrollTop=0
    }
}
</script>
<style scoped>
.wei{
    background: #e2e0e0;
    font-size: 14px;
 }
 .wei>div{
    width: 1200px;
    margin: 10px auto 20px;
    padding: 10px 0;
 }
 .xiang{
     width: 1200px;
     margin: 15px auto  30px;
     display: flex;
     justify-content: space-between;
 }
 .left>div:first-child{
     width:231px;
     height:46px;
     background:rgba(234,0,4,1);
     text-align: center;
     font-size:24px;
     font-family:Microsoft YaHei;
     font-weight:bold;
     color:rgba(255,255,255,1);
     line-height:47px;
 }
 .left{
     width: 231px;
 }
 .right{
     width: 960px;
 }

</style>